export class BaseCatalogue {
  public name: string;

  constructor(name: string) {
    this.name = name;
  }
}
